import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { getImage, GatsbyImage as Img } from 'gatsby-plugin-image'
import styled from 'styled-components'
import Box, { borderRadiuses } from '../UI/Box'
import {
  width,
  space,
  maxHeight,
  minHeight,
  minWidth,
  maxWidth,
  height,
  flex,
  compose,
} from 'styled-system'
import { Loader } from '../Loader'

const imgProps = compose(
  flex,
  width,
  space,
  maxHeight,
  minHeight,
  minWidth,
  maxWidth,
  height,
  borderRadiuses
)

const ImgBox = styled(Img)(imgProps)

ImgBox.defaultProps = {
  width: 1,
}

const PreviewCompatibleImage = ({
  alt = '',
  image,
  styles,
  imgStyle,
  cover,
  showLoading,
  backgroundColor,
  ...rest
}) => {
  const gatsbyImage = getImage(image)

  const imageStyle = cover
    ? {
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        ...styles,
      }
    : {
        ...styles,
      }

  const [loading, setLoading] = useState(true)

  const endLoading = () => {
    setLoading(false)
  }

  if (gatsbyImage) {
    return (
      <>
        <ImgBox
          onLoad={endLoading}
          {...rest}
          loading="eager"
          style={imageStyle}
          imgStyle={imgStyle}
          image={gatsbyImage}
          alt={alt}
          backgroundColor={backgroundColor}
        />
        <Loader show={loading && showLoading} />
      </>
    )
  }

  if (!!image && (typeof image === 'string' || typeof image?.src === 'string'))
    return (
      <Box {...rest}>
        <img
          className="img-string-src"
          style={imageStyle}
          src={image.src ?? image}
          alt={alt}
        />
      </Box>
    )

  return null
}

PreviewCompatibleImage.propTypes = {
  alt: PropTypes.string,
  backgroundColor: PropTypes.string,
  cover: PropTypes.bool,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  imgStyle: PropTypes.object,
  showLoading: PropTypes.bool,
  styles: PropTypes.object,
}

export default PreviewCompatibleImage
